module.exports = __webpack_public_path__ + "img/1F630.6e08c196.svg";